// src/components/Footer.jsx
import React from 'react';
import logo from './img/sigma-key-logo.png';
import { isMobile, isTablet } from 'react-device-detect';
import './../../style/Vars.css'
import './../../style/ElementsStyle.css'
import './../../style/ContainersStyles.css'

export default function Footer() {
  const footerClass = isMobile || isTablet ? 'footer footer-mobile' : 'footer';
  const logoClass = isMobile || isTablet ? 'footer-logo footer-logo-mobile' : 'footer-logo';

  return (
    <footer className={footerClass}>
      <img src={logo} alt="Footer Logo" className={logoClass} />
      <p><strong>SigmaKey - Derechos reservados Sociedad Economista Maya © {new Date().getFullYear()}</strong> </p>
    </footer>
  );
}
